const initialState = {
	isDesktop: false,
	isMobile: false,
};

export default function (state = initialState, action: any) {
	switch (action.type) {
		case "SET_IS_DESKTOP": {
			return {
				...state,
				isDesktop: action.data,
			};
		}
		case "SET_IS_MOBILE": {
			return {
				...state,
				isMobile: action.data,
			};
		}
		default:
			return state;
	}
}
